export default "__VITE_ASSET__7f5a9066__"